
import React from 'react';
import { FacilityOrderTemplateNewFlowUSIntakeTemplateActivationModalTemplate} from 'themes/application/facility-order-new-flow-us-intake/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderTemplateNewFlowUSIntakeTemplateActivationModalStore } from 'application/facility-order-new-flow-us-intake/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplateNewFlowUSIntakeTemplateActivationModalStore(rootStore, componentProps), 'facilityOrderTemplateNewFlowUSIntakeTemplateActivationModalStore')
@observer
class FacilityOrderTemplateNewFlowUSIntakeTemplateActivationModal extends React.Component {
    render() {
        return <FacilityOrderTemplateNewFlowUSIntakeTemplateActivationModalTemplate {...this.props} />
    }
}

export default FacilityOrderTemplateNewFlowUSIntakeTemplateActivationModal;